import React from 'react';

const Modal = ({ message, onClose, isSuccess }) => {
  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <h3 style={{ color: isSuccess ? 'green' : 'red' }}>{isSuccess ? 'Success!' : 'Error!'}</h3>
        <p>{message}</p>
        <button className= "add-new-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
  },
};

export default Modal;